import React from 'react'
import { Tag } from '@pankod/refine-antd'
import clsx from 'clsx'

type TStatusTagProps = {
  active: boolean
  activeText?: string
  className?: string
  inactiveText?: string
}

export const StatusTag = ({
  active,
  activeText = 'FINALIZED',
  className,
  inactiveText = 'DRAFT',
}: TStatusTagProps) => (
  <Tag
    className={clsx('!m-0', className)}
    color={active ? 'processing' : 'default'}
  >
    {active ? activeText : inactiveText}
  </Tag>
)
